/**
 * A parish's name where a letter, a card or a letter's check names the issuing parish (owner,
 * 2026-10-04: the cathedral's unit is named "Katedral Salib Suci Agats", so its letters read
 * "menurut Buku Baptis Katedral Salib Suci Agats"). The screens keep the name as stored (the
 * header, the Pelayan headings read well without "Paroki"); `tanpaKataParoki` (./pelayan) is the
 * other way, for words that already say "Paroki". Pure and dependency-free, so the public letter
 * check imports it alone.
 */

/**
 * "Paroki " before the name, unless it starts with "Paroki" or "Kuasi Paroki" already (any
 * case): "Katedral Salib Suci Agats" → "Paroki Katedral Salib Suci Agats"; "Paroki St. Petrus
 * Sawa Erma" and "Kuasi Paroki St. Fransiskus Atsj" stay, never "Paroki Paroki …" or "Paroki
 * Kuasi Paroki …". Trimmed; an empty name stays empty.
 */
export function namaParokiLengkap(nama: string): string {
  const n = nama.trim()
  if (n === '' || /^(kuasi\s+)?paroki(\s|$)/i.test(n)) return n
  return `Paroki ${n}`
}
